<template>
	<div id="profile-form" class="container page-container" v-if="user.isAdmin">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <h1>Add a User</h1>
        <el-form :model="addUserForm" :rules="rules" :label-position="labelPosition" ref="addUserForm" label-width="100px" class="ruleForm">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="Email" prop="email">
                <el-input v-model="addUserForm.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item label="Password" prop="pass">
                <el-input type="password" v-model="addUserForm.pass"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
              <el-form-item>
                <el-button @click="submitForm('addUserForm')">Add User</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-col>
    </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <h1>Manage Users</h1>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(user, index) in users" :key="user.email">
          <el-card class="box-card">
            <div class="text item">
              <span class="user-title">{{user.email}}</span>
              <el-button style="float: right;" @click.prevent="$router.push('/users/' +user['.key'])">Manage</el-button>
              <div class="cf"></div>
              <span class="edited" v-if="user.isAdmin !== false">Admin</span>
              <span class="edited" v-if="user.isAdmin == false">Client</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
	</div>
</template>
<script>
import { db, authService } from '../helpers/helpers'
import moment from 'moment'
let projectsRef = db.ref('projects')
let usersRef = db.ref('users')
export default {
  name: 'profiles',
  firebase: {
    projects: projectsRef,
    users: usersRef
  },
  data () {
    return {
      auth: authService,
      labelPosition: 'top',
      addUserForm: {
        email: '',
        pass: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please enter your email address', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ],
        pass: [
          { required: true, message: 'Please enter your password', trigger: 'blur' },
          { min: 6, message: 'Your password is too short!' }
        ]
      }
    }
  },
  methods: {
    prettyDate (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var email = this.addUserForm.email
          var pass = this.addUserForm.pass
          this.auth.userCreate(email, pass)
          this.addUserForm.email = ''
          this.addUserForm.pass = ''
        } else {
          console.log('There was an error!')
          return false
        }
      })
    }
  },
  created: function () {
    this.$bindAsObject('user', usersRef.child(this.auth.user.uid))
  }
}
</script>
<style>

  .user-title {
    line-height: 22px;
    font-size: 22px;
    display: inline-block;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .item .el-switch__label * {
    font-size: 9px;
    line-height: 1.6em;
  }

</style>


// WEBPACK FOOTER //
// Users.vue?634825ca